getUserVideo